import React from 'react';
import { useNavigate } from 'react-router-dom'; // <--- Import this
import './Newsletter.css';

const Newsletter = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <section className="newsletter-section">
      <div className="container newsletter-content">
        <h2>Sign up for our free newsletter</h2>
        {/* Update onClick to navigate */}
        <button 
            className="btn-newsletter" 
            onClick={() => navigate('/market-highlights')}
        >
            Free Newsletter
        </button>
      </div>
    </section>
  );
};

export default Newsletter;